import Sidebar from "../components/sidebar";
import AddForm from "../components/addform";
import ChangePassword from "../components/changePassword";
import Login from "../components/login";
import Navbar from "../components/navbar";
import EditForm from "../components/editform";

function EditFormPage() {
  return (
    <>
      <Sidebar>
        <EditForm />
      </Sidebar>
    </>
  );
}
export default EditFormPage;
